module.exports = __webpack_public_path__ + "static/media/londonCanada.ac049c2c.png";